import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './user-group.types';
import * as constants from './user-group.constants';

export const storeUserGroup = generateStoreResourceAction<types.IUserGroup>(constants.STORE_USER_GROUP);
export const clearUserGroup = generateClearResourceAction(constants.CLEAR_USER_GROUP);
